import React from "react";
import { Arrow } from "react-konva";

import { IStatsPassProps } from "./types";
import * as Config from "./configuration";
import { validCoordinate } from "./utils";

const getColor = (result: boolean, threat: boolean) => {
  if (threat) {
    return result
      ? Config.PASS_COLOR_ASSIST_SUCC
      : Config.PASS_COLOR_ASSIST_FAIL;
  }
  return result ? Config.PASS_COLOR_SUCC : Config.PASS_COLOR_FAIL;
};

export const StatsPass = ({ from, to, result, threat }: IStatsPassProps) => {
  if (!validCoordinate(from) || !validCoordinate(to)) {
    return null;
  }
  const color = getColor(result, threat);
  return (
    <Arrow
      points={[from.x, from.y, to.x, to.y]}
      pointerLength={Config.ARROW_SIZE}
      pointerWidth={Config.ARROW_SIZE}
      fill={color}
      stroke={color}
      strokeWidth={Config.STROKEWIDTH}
    />
  );
};
